import formatFileSize from './utils'

const messages = {
  _default: () => `ist ungültig.`,
  after: (field, [target]) => `muss nach ${target} liegen.`,
  alpha_dash: () =>
    `darf alphanumerische Zeichen sowie Striche und Unterstriche enthalten.`,
  alpha_num: () => `darf nur alphanumerische Zeichen enthalten.`,
  alpha: () => `darf nur alphabetische Zeichen enthalten.`,
  before: (field, [target]) => `muss vor ${target} liegen.`,
  between: (field, [min, max]) => `muss zwischen ${min} und ${max} liegen.`,
  confirmed: (field, [confirmedField]) =>
    `passt nicht zum Inhalt von ${confirmedField}.`,
  date_between: (field, [min, max]) =>
    `muss zwischen ${min} und ${max} liegen.`,
  date_format: (field, [format]) => `muss das Format ${format} haben.`,
  decimal: (field, [decimals = '*'] = []) =>
    `muss numerisch sein und darf ${
      decimals === '*' ? '' : decimals
    } Dezimalpunkte enthalten.`,
  digits: (field, [length]) =>
    `muss numerisch sein und exakt ${length} Ziffern enthalten.`,
  dimensions: (field, [width, height]) =>
    `muss ${width} x ${height} Bildpunkte groß sein.`,
  email: () => `muss eine gültige E-Mail-Adresse sein.`,
  ext: () => `muss eine gültige Datei sein.`,
  image: () => `muss eine Grafik sein.`,
  in: () => `muss ein gültiger Wert sein.`,
  ip: () => `muss eine gültige IP-Adresse sein.`,
  max: (field, [length]) => `darf nicht länger als ${length} Zeichen sein.`,
  mimes: () => `muss einen gültigen Dateityp haben.`,
  min: (field, [length]) => `muss mindestens ${length} Zeichen lang sein.`,
  not_in: () => `muss ein gültiger Wert sein.`,
  numeric: () => `darf nur numerische Zeichen enthalten.`,
  regex: () => `Das Format von ist ungültig.`,
  required: () => `ist ein Pflichtfeld.`,
  size: (field, [size]) => `muss kleiner als ${formatFileSize(size)} sein.`,
  url: () => `ist keine gültige URL.`,
  fullName: () => 'ist nicht gültig (Name, Vorname und max. 120 Zeichen)',
  emailInput: () => 'muss eine gültige E-Mail-Adresse sein.',
  fullNamePerCountry: () => 'ist nicht gültig (Name, Vorname und max. 18 Zeichen)',
  orderNumberPerCountry: () => `ist zu lang`,
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'de',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/de.js